import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {APP_CONFIG} from '@synthroneApp/app.config';

import {MatDialog} from '@angular/material';
import {AlertComponent} from '@angular/synthrone-design/components';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';

@Component({
    selector: 'app-sections-view',
    templateUrl: './sections-view.component.html',
    styleUrls: ['./sections-view.component.scss']
})

export class SectionsViewComponent implements OnInit {

    @ViewChild('sectionsTable') sectionsTable;

    configColumns = {
        name: {
            label: 'Name',
            sortable: true,
            truncate: true
        },
        title: {
            label: 'Title',
            sortable: true,
            truncate: true
        }
    };

    queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    timeout = null;
    tableFilter = {
        'search': ''
    } 

    constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog, private messagesService: MessagesService) {
    }

    ngOnInit() {
        this.tableFilter = {
            'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search']
        }
    }

    setParams = () => {
        this.queryParams['search'] = this.tableFilter.search;
    };

    refreshTable = () => {
        this.sectionsTable.getData()
    };

    add = () => {
        this._router.navigate(['/sections/add']);
    };

    editRow = (key) => {
        this._router.navigate(['/sections/edit', key]);
    };

    deleteRow = (key) => {
        let dialogRef = this.dialog.open(AlertComponent, {
            data: {
                message: 'Are you sure that you want to delete this section?'
            }
        }).afterClosed().subscribe(result => {
            if (result == 'proceed') {
                this.api.makeRequest('api_system_section_delete', {
                    id: key
                }, 'crafter').subscribe(
                    (result) => {
                        if (this._router.url === '/sections') {
                            this.sectionsTable.getData();
                        } else {
                            this._router.navigate(['/sections']);
                        }
                    },
                    (error) => {
                        this.messagesService.showSnack(error, "error");
                    }
                );
            }
        });
    };

    getTableData = (limit, offset, sortBy, sortOrder): Observable<any> => {
        return this.api.makeRequest('api_system_section_list', {
            seed: new Date().getTime(),
            offset: offset,
            limit: limit,
            sortBy: sortBy,
            sortOrder: sortOrder,
            filterValue: this.tableFilter.search
        }, 'crafter');
    }

    searchProductFN = () => {
     
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setParams();
          this._router.navigate(['/sections/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
          this.refreshTable();
        }, 2000);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/views/sections-view/sections-view.component.ts